import React from "react";

const Navigation = ({ isActive, onClick, visible, ...rest }) => (
    <nav className={[`navigation`, `navigation--${isActive ? 'active' : 'not-active'}`, `${visible ? `navigation--is-visible` : `navigation--not-visible`}`].join( ` ` )} onClick={ onClick } >
        <button tabIndex="0" className={ `navigation-button` } onClick={ onClick }  />
    </nav>
)

export default Navigation